export default {
  textMap: {
    "边缘计算特征值": "Измерение",
    "分段柱状图": "Столбчатая диаграмма секторов",
    "叶片频率": "Частота лопаток",
    "趋势图": "Тренд",
    "轨迹图": "Орбита",
    "瀑布图": "Водопад",
    "全频谱瀑布图": "Водопад полного спектра",
    "倒谱图": "Кепстр",
    "包络": "Огибающая",
    "使用当前时间": "Использовать текущее время",
    "放大": "Увеличить",
    "放大还原": "Восстановить масштаб",
    "还原到上一级": "Вернуться на предыдущий уровень",
    "导出": "Экспортировать",
    "全屏": "Полноэкранный режим",
    "退出全屏": "Выйти из полноэкранного режима",
    "主游标": "Основной курсор",
    "辅游标": "Вспомогательный курсор",
    "标点": "Отметка",
    "取消标点": "Отменить отметку",
    "自动寻峰": "Пики",
    "谐频": "Гармоника",
    "边频": "Боковая частота",
    "更多": "Больше",
    "阶次": "Порядок",
    "赫兹": "Гц",
    "标注": "Метка",
    "取消标注": "Снять метку",
    "清除": "Очистить",
    "删除图谱": "Удалить график",
    "历史概貌图": "Истрический обзор",
    "显示报警线": "Показать пороговые значения",
    "隐藏报警线": "Скрыть пороговые значения",
    "多参数分析波形图": "Мультиграфик временного сигнала",
    "波形图": "Временной сигнал",
    "频谱图": "Спектр",
    "全频谱图": "Полный спектр",
    "单值棒图": "Простая столбчатая диаграмма",
    "多值棒图": "Столбчатая диаграмма с группировкой",
    "图": "График",
    "进动方向": "Направление прецессии",
    "正向": "Прямая",
    "反向": "Обратное",
    "差量": "Смещение",
    "天": "Д",
    "时": "Ч",
    "秒": "с",
    "分": "Мин",
    "多特征值": "Измерения",
    "气体载荷": "Газовая нагрузка",
    "惯性载荷": "Инерционная нагрузка",
    "活塞杆载荷": "Нагрузка на шток поршня",
    "振动波形": "Временной сигнал вибрации",
    "活塞杆载荷监测": "Нагрузка на шток поршня",
    "幅值转速": "Амплитуда - Скорость",
    "相位转速": "Фаза - Скорость",
    "缸号": "Номер цилиндра",
    'p-v图': 'Диаграмма P-V',
    'p-a图': 'Диаграмма P-A',
    'p-t图': 'Диаграмма P-T',
    'logP-logV图': 'Диаграмма logP-logV',
    "Y轴最小值输入": "Минимум по оси Y",
    "X轴最大值输入": "Максимум по оси X",
    "Y轴最大值输入": "Максимум по оси Y",
    "显示转速": "Показать скорость",
    "隐藏转速": "Скрыть скорость",
    "趋势图时间单位": '[Время]',
    "波形图时间单位": '[С]',
    "暂无报警线信息": "Пороговые значения недоступны",
    "高高报": "Уставка HH",
    "高报": "Уставка H",
    "低低报": "Уставка LL",
    "低报": "Уставка L",
    "输入字符非法，请重新输入" : "Недопустимый ввод. Повторите.",
    "已达到图谱数量显示上限": "Достигнут предел числа графиков",
    "时间戳:": "Отметка времени:",
    "查询时间": "Запрос",
    "切换": "Переключить",
    "转速": "Скорость",
    "传统概貌图":"Традиционный обзор",
    "设备概貌图": "Оборудование",
    "工艺流程图": "Техпроцесс",
    "柱状图": "Столбчатая диаграмма",
    "全级联图": "Полная каскадная диаграмма",
    "级联图": "Каскадная диаграмма",
    "轴心位置": "Положение центра вала",
    "轴心轨迹": "Орбита",
    "操作页": "Страница управления",
    "开车": "Запуск",
    "停车": "Остановка",
    "未知": "Неизвестно",
    "总值": "Действующее значение Пик (Временной сигнал)",
    "平均值": "Среднее (Временной сигнал)",
    "整流平均值": "Среднее выпрямленное (Временной сигнал)",
    "峰峰值": "Пик-Пик (размах) (Временной сигнал)",
    "波形标准差": "Среднеквадратичное отклонение (Временной сигнал)",
    "峭度因子": "Эксцесс (Временной сигнал)",
    "脉冲因子": "Импульсность (Временной сигнал)",
    "波形因子": "Пик-фактор (Временной сигнал)",
    "裕度因子": "Запас (Временной сигнал)",
    "歪度因子": "Асимметрия (Временной сигнал)",
    "峰值因子": "Пиковость (Временной сигнал)",
    "高频总量": "Пик Сумм - Высокие частоты",
    "中频总量": "Пик Сумм - Средние частоты",
    "低频总量": "Пик Сумм - Низкие частоты",
    "高频能量": "Энергия - Высокие частоты",
    "中频能量": "Энергия - Средние частоты",
    "低频能量": "Энергия - Низкие частоты",
    "频谱有效值": "RMS (Спектр)",
    "频谱均值": "Среднее (Спектр)",
    "频率重心": "Центроид (Спектр)",
    "频谱峰值": "Макс (Спектр)",
    "内圈幅值": "Амплитуда Пик - Внутреннее кольцо",
    "外圈幅值": "Амплитуда Пик - Наружное кольцо",
    "滚动体幅值": "Амплитуда Пик - Вращение тела качения",
    "保持架幅值": "Амплитуда Пик - Сепаратор",
    "特征选择": "Категория",
    "全选": "Выбрать все",
    "内圈特征频率": "Характерная частота - Внутреннее кольцо",
    "外圈特征频率": "Характерная частота - Наружное кольцо",
    "滚动体特征频率": "Характерная частота - Вращение тела качения",
    "保持架特征频率": "Характерная частота - Сепаратор",
    "内圈": "Внутреннее кольцо",
    "外圈": "Наружное кольцо",
    "滚动体": "Тело качения",
    "保持架": "Сепаратор",
    "转子条频率": "Стержни ротора",
    "定子槽频率": "Пазы статора",
    "时域特征（幅值）": "Временной сигнал (Общий)",
    "时域特征（指标）": "Временной сигнал (Множитель)",
    "频域特征（通频）": "Спектр (Общий уровень вибрации)",
    "频域特征（选频）": "Спектр (На отдельной частоте)",
    "故障特征频率": "Частота неисправности",
    "计算轴承": "Частота подшипника",
    "轴承型号": "Модель подшипника",
    "请输入正确的转速!": "Пожалуйста, введите правильную скорость!",
    "滚动体直径或滚动轴承的节圆直径不能为0!": "Диаметр тела качения или средний диаметр сепаратора не может быть равен нулю!",
    "通频": "Общий уровень вибрации",
    "1倍频幅值": "Амплитуда 1X",
    "2倍频幅值": "Амплитуда 2X",
    "3倍频幅值": "Амплитуда 3X",
    "1/2倍频幅值": "Амплитуда 0,5X",
    "自定义": "Произвольный порядок",
    "过滤类型": "Тип фильтра",
    "倍频幅值": "Порядок",
    "残振": "Остаточная вибрация",
    "峰值": "Пик",
    "峭度": "Эксцесс",
    "歪度": "Асимметрия",
    "最大值": "Макс",
    "最小值": "Мин",
    "压力": "Давление",
    "振动": "Вибрация",
    "温度": "Температура",
    "流量": "Расход",
    "其它": "Другое",
    "撞击": "Удар",
    "直流量": "Значение DC",
    "有效值": "Среднеквадратичное значение",
    "平均压力": "Среднее давление",
    "机械效率": "Механическая эффективность",
    "吸气容积效率": "Объёмная эффективность всасывания",
    "排气容积效率": "Объёмная эффективность нагнетания",
    "单缸指示功率": "Индикаторная мощность одного цилиндра",
    "压缩指数": "Коэффициент сжатия",
    "膨胀系数": "Коэффициент расширения",
    "实际压力比": "Фактическое давление",
    "沉降量/偏摆量": "Усредненное положение",
    "峰-峰值": "Пик-Пик (размах)",
    "活塞-气缸剩余间隙": "Зазор между поршнем и цилиндром",
    "一倍频幅值": "Амплитуда 1X",
    "二倍频幅值": "Амплитуда 2X",
    "间隙电压": "Напряжение зазора",
    "加速度峰值": "Виброускорение Действующее значение Пик",
    "加速度高频": "Виброускорение Действующее значение Пик - Высокие частоты",
    "加速度低频": "Виброускорение Действующее значение Пик - Низкие частоты",
    "加速度波形峭度": "Эксцесс ускорения",
    "速度有效值": "Виброскорость RMS",
    "通频gIE值": "gIE",
    "加速度真峰值": "Виброускорение Пик",
    "通频有效值": "RMS",
    "1倍频有效值": "Амплитуда RMS 1X",
    "2倍频有效值": "Амплитуда RMS 2X",
    "3倍频有效值": "Амплитуда RMS 3X",
    "1/2倍频有效值": "1/2 RMS",
    "残振有效值": "Остаточное значение RMS",
    "无线振动速度有效值": "Виброскорость RMS (беспроводн.)",
    "无线振动位移峰值": "Виброперемещение Пик (беспроводн.)",
    "无线振动加速度有效峰值": "Виброускорение Действующее значение Пик (беспроводн.)",
    "振动速度有效值": "Виброскорость RMS",
    "振动加速度有效峰值": "Виброускорение Действующее значение Пик",
    "振动加速度低频值": "Виброускорение Действующее значение Пик - Низкие частоты",
    "振动加速度真峰值": "Виброускорение Пик",
    "振动位移峰峰值": "Виброперемещение Пик-Пик",
    "1倍频相位": "Фаза 1X",
    "2倍频相位": "Фаза 2X",
    "3倍频相位": "Фаза 3X",
    "1/2倍频相位": "Фаза 0,5X",
    "寻峰个数:": "Номер пика:",
    "谐频倍数:": "Номер гармоники:",
    "缺陷频率:": "Частота дефекта:",
    "叶片频率:": "Частота лопаток:",
    "显示": "Показать",
    "隐藏": "Спрятать",
    "事件描述:": "Описание события:",
    "输入事件内容": "Введите описание события.",
    "事件查询": "Запрос события",
    "图谱显示:": "График:",
    "分析线数:": "Количество линий БПФ:",
    "比较类型:": "Тип:",
    "径向振动": "Радиальная вибрация",
    "轴向位移": "Осевой сдвиг",
    "设备名称:": "Оборудование:",
    "事件查询:": "Запрос события:",
    "类型选择:": "Отсортировать по:",
    "请选择类型": "Выберите тип",
    "请选择缸号": "Выберите номер цилиндра",
    "请选择图谱": "Выберите график",
    "请输入数字": "Введите номер порядка",
    "选择分析线数": "Выбор числа линий БПФ",
    "趋势类型:": "Тип тренда:",
    "图谱选择:": "График:",
    "图谱显示": "Тренд",
    "时间选择:": "Диапазон времени:",
    "模式选择:": "Дата от:",
    "转速时间": "Скорость - Время",
    "波德图": "Диаграмма Боде",
    "相位时间": "Фаза-Время",
    "极坐标图": "Полярная диаграмма",
    "查询": "Запрос",
    "刷新": "Обновить",
    "停止": "Остановить",
    "启停车日志:": "Журнал событий:",
    "事件id": "ID события",
    "事件标记描述": "Описание cобытия",
    "状态": "Статус",
    "转速(r/min)": "Скорость (об/мин)",
    "日志": "Журнал",
    "开始时间:": "От:",
    "结束时间:": "До:",
    "使用": "Активировать",
    "不使用": "Деактивировать",
    "选择年月:": "Месяц:",
    "yyyy 年 MM 月": "MM.yyyy",
    "实时": "Реальное время",
    "历史": "Исторический",
    "参数区间:": "Параметр:",
    "选择测点:": "Точки измерения:",
    "全部": "Все",
    "曲轴箱": "Картер",
    "1缸": "Цилиндр 1",
    "2缸": "Цилиндр 2",
    "3缸": "Цилиндр 3",
    "4缸": "Цилиндр 4",
    "5缸": "Цилиндр 5",
    "6缸": "Цилиндр 6",
    "趋势": "Тренд",
    "波形": "Временной сигнал",
    "频谱": "Спектр",
    "缸号选择:": "Отсортировать по:",
    '特征': 'Измерение',
    '壳体振动': 'Вибрация корпуса',
    '曲轴箱振动': 'Вибрация картера',
    "其它振动": "Другие вибрации",
    '活塞杆沉降/偏摆': 'Положение поршня',
    '动态压力': 'Динамическое давление',
    "启停车测点": "Радиальная вибрация",
    "振动-加速度": "Виброускорение",
    "振动-位移": "Виброперемещение",
    "振动-速度": "Виброскорость",
    "位移": "Виброперемещение",
    "湿度": "Влажность",
    "加速度": "Виброускорение",
    "速度": "Виброскорость",
    "撞击次数": "Количество ударов",
    "温度测点": "Температура",
    "压力测点": "Давление",
    "流量测点": "Расход",
    "振动测点": "Радиальная вибрация",
    "轴心轨迹测点树关键字": "Пара каналов",
    "轴心位置测点树关键字": "Пара каналов",
    "频率": "Частота",
    "相位": "Фаза",
    "不同测点": "Множественный",
    "相同测点": "Единственный",
    "前一阶段": "Диапазон времени",
    "起止时间": "От - До",
    "起止月": "Месяц",
    "前5分钟": "Последние 5 минут",
    "前半小时": "Последние 30 минут",
    "前1小时": "Последний 1 час",
    "前1天": "Последний 1 день",
    "前1周": "Последняя 1 неделя",
    "前1月": "Последний 1 месяц",
    "前1季度": "Последние 3 месяца",
    "前1年": "Последний 1 год",
    "时间选择错误": "Ошибка выбора времени",
    "请确保开始时间早于终止时间": "Убедитесь, что время начала раньше времени окончания",
    "确定": "Да",
    '搜索组织结构': 'Поиск',
    '筛选设备类型': 'Фильтрация по типу оборудования',
    '旋转': 'Вращающееся оборудование',
    '燃气轮机': 'Газовая турбина',
    '往复': 'Поршневые машины',
    '机泵': 'Общее оборудование (проводн.)',
    '风电': 'Ветряная турбина',
    '燃气发动机': 'Газовый двигатель',
    '内燃机': 'Двигатель внутреннего сгорания',
    '无线机泵': 'Общее оборудование (беспроводн.)',
    '组织机构': 'Организация',
    "旋转机械专用图谱": "Вращающееся оборудование",
    "振动监测": "Вибрация",
    "机组概貌图": "Обзор",
    "单多值棒图": "Столбчатая диаграмма",
    "温度分布场": "Распределение температуры",
    "振动历史比较": "Сравнение вибрации",
    "其它参数趋势图": "Статические параметры",
    "综合分析": "Комплексный анализ",
    "冲击诊断": "gIE",
    "轴心轨迹-菜单关键字": "Орбита вала",
    "轴心位置-菜单关键字": "Положение вала",
    "全频谱图-菜单关键字": "Полный спектр",
    "启停车图形": "График пуска/остановки",
    "旋转报警查询": "Запрос тревог",
    "参数比较查询": "Запрос сравнения параметров",
    "运行状态图": "Мультитренд",
    "倒谱图-菜单关键字": "Кепстр",
    "往复机械专用图谱": "Поршневые машины",
    "单值棒图-菜单关键字": "Столбчатая диаграмма",
    "历史比较图": "Сравнение вибрации",
    "综合监测": "Комплексный мониторинг",
    "活塞杆沉降/偏摆监测-菜单关键字": "Позиция штока поршня",
    "示功图": "Динамическое давление",
    "多参数分析-菜单关键字": "Мультиграфик временного сигнала",
    "往复报警查询": "Запрос тревог",
    "机泵报警查询": "Запрос тревог",
    "趋势分析": "Вибрация",
    "分析图谱": "Инструменты анализа",
    "机泵专用图谱": "Общее оборудование (проводн.)",
    "活塞杆载荷分析": "Нагрузка на шток поршня",
    "无线机泵专用图谱": "Общее оборудование (беспроводн.)",
    "波形频谱对比分析": "Сравнение вибрации",
    "边缘计算特征值趋势图": "Тренд измерений",
    "报警查询": "Запрос тревог",
    "语言": "Язык",
    "中文": "Китайский",
    "英文": "Английский",
    "俄文": "Русский",
    "更改主题": "Сменить тему",
    "静谧蓝": "Спокойствие",
    "默认": "По умолчанию",
    "暗黑": "Темная",
    "无数据": "Нет данных",
    "范围内无数据点": "Нет данных за период",
    "数据加载中": "Загрузка данных...",
    "数据获取失败": "Ошибка получения данных",
    "请选择事件": "Пожалуйста, выберите событие",
    "缺陷频率无数据": "Частота дефекта недоступна",
    "请输入标注": "Пожалуйста, введите аннотацию",
    "取消": "Отменить",
    "选择开始时间": "Выбрать время начала",
    "选择结束时间": "Выбрать время окончания",
    "关注": "Следовать",
    "取消关注": "Отменить следование",
    "显示全部点": "Все точки",
    "仅显示波形点": "Показать только точки временного сигнала",
    "仅显示长波形点": "Показать только точки долгого временного сигнала",
    "X轴真峰值": "Пик (X)",
    "X轴有效峰值": "Действующее значение Пик (X)",
    "X轴有效值": "СКЗ (X)",
    "X轴峰峰值": "Пик-Пик (X)",
    "Y轴真峰值": "Пик (Y)",
    "Y轴有效峰值": "Действующее значение Пик (Y)",
    "Y轴有效值": "СКЗ (Y)",
    "Y轴峰峰值": "Пик-Пик (Y)",
    "Z轴真峰值": "Пик (Z)",
    "Z轴有效峰值": "Действующее значение Пик (Z)",
    "Z轴有效值": "СКЗ (Z)",
    "Z轴峰峰值": "Пик-Пик (Z)",
    "MCU温度": "Температура MCU",
    "振动趋势图": "Тренд вибрации",
    "转速趋势图": "Тренд скорости вращения",
    "X轴加速度": "Виброускорение (X)",
    "Y轴加速度": "Виброускорение (Y)",
    "Z轴加速度": "Виброускорение (Z)",
    "无线toC设备专用图谱": "Беспроводной инструмент для анализа",
    "补偿": "Компенсация данных",
    "无": "Без компенсации",
    "从数据库选择": "Выбрать датасет",
    "第一个样本": "Первый датасет",
    "最后一个样本": "Последний датасет",
    "当前样本": "Текущий датасет",
    "创建新数据集": "Создать новый датасет",
    "未选中补偿点": "Датасет не выбран",
    "通频振动": "Общий уровень вибрации",
    "低压转子1X振动": "1X амплитуда (низкое давление)",
    "低压转子2X振动": "2X амплитуда (низкое давление)",
    "低压转子谐波振动": "Амплитуда гармоники (низкое давление)",
    "高压转子1X振动": "1X амплитуда (высокое давление)",
    "高压转子2X振动": "2X амплитуда (высокое давление)",
    "高压转子谐波振动": "Амплитуда гармоники (высокое давление)",
    "动力涡轮1X振动": "1X амплитуда (силовая турбина)",
    "动力涡轮2X振动": "2X вибрация (силовая турбина)",
    "动力涡轮谐波振动": "Амплитуда гармоники (силовая турбина)",
    "低频残振": "Амплитуда остаточной вибрации низкой частоты",
    "高频残振": "Амплитуда остаточной вибрации высокой частоты",
    "燃气轮机专用图谱": "Газовая турбина",
    "未选中补偿数据集": "Не выбран набор данных компенсации",
    "获取失败": "Не удалось получить",
    "名称": "Имя",
    "请输入名称": "Пожалуйста, введите название набора данных компенсации",
    "请选择子类型": "Пожалуйста, выберите подтип",
    "至少选择一个补偿范围": "Пожалуйста, выберите хотя бы один диапазон компенсации",
    "创建成功": "Создано успешно",
    "创建失败": "Не удалось создать",
    "序号": "Нет.",
    "类型": "Тип",
    "子类型": "Подтип",
    "时间戳": "Временная метка",
    "操作": "Действие",
    "删除成功": "Успешно удалено",
    "删除失败": "Не удалось удалить",
    "设置成功": "Настройки успешно сохранены",
    "设置失败": "Не удалось сохранить настройки",
    "未选中样本": "Семпл не выбран",
    "启动": "Запуск",
    "停机": "Остановка",
    "其他": "Другой",
    "热": "Горячий",
    "冷": "Холодный",
    "矢量": "Вектор",
    "间隙": "Зазор",
    "补偿范围": "Объем компенсации",
    "保存": "Сохранить",
    "数据导出": "Экспорт данных",
    "包络波形": "Временной сигнал огибающей",
    "包络频谱": "Спектр огибающей",
    "包络方式": "Фильтр",
    "高通": "Фильтр верхний частот",
    "带通": "Полосовой фильтр",
    "截止频率": "Частота среза",
    "上截止频率": "Верхняя частота среза",
    "下截止频率": "Нижняя частота среза",
    "请输入截止频率":"Пожалуйста, введите частоту среза.",
    "平均值（轴向位移）": "Среднее",
    "没有设置报警门限": "Порог срабатывания сигнализации не установлен",
    "断网": "Отключить",
    "正常": "Нормальные",
    "智能一级": "Умное предупреждение I",
    "智能二级": "Умное предупреждение II",
    "智能三级": "Умное предупреждение III",
    "固定高报": "Сигнализация по уставке H",
    "固定高高报": "Сигнализация по уставке HH",
    '频谱瀑布图': 'Водопад',
    '峰值趋势': 'Тренд Пиковых значений',
    '分析诊断': 'Инструменты анализа',
    '时间': 'Время',
    '测点': 'Точка измерений',
    '趋势特征值': 'Тренд измерений',
    '测量类型': 'Категория измерений',
    '特征类型': 'Измерение',
    '缓变量测点': 'Точка измерений техпроцесса',
    '平均值（特征值）': 'Среднее',
    '峰峰值（特征值）': 'Действующее значение Пик-Пик',
    'gIE值': 'gIE',
    '真峰值': 'Пик',
    '真峰峰值': 'Пик-Пик',
    '加速度冲击': 'Ударное виброускорение',
    '振动趋势': 'Тренд вибрации',
    '包络分析': 'Анализ огибающей',
    '缓变量趋势': 'Тренд техпроцесса',
  },
};



// WEBPACK FOOTER //
// ./src/language/ru.js